module.exports = __webpack_public_path__ + "img/processamento-documento.6a28862a.svg";